<template>
    <div class="class-update-wrapper">
        <a-modal
            class="class-update"
            :visible="visible"
            :title="form.getFieldValue('id') ? $t('program.modify_topic_forum' /* 修改专题分论坛 */) : $t('program.add_topic_forum' /* 添加专题分论坛 */)"
            :width="600"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item :hidden="true">
                    <a-input v-decorator="['id']"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.cn_name' /* 中文名称 */)">
                    <a-input
                        v-decorator="['class_cnname', { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('program.cn_name' /* 中文名称 */) }] }]"
                        :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('program.cn_name' /* 中文名称 */)"
                    ></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.en_name' /* 英文名称 */)">
                    <a-input v-decorator="['class_enname']" :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('program.en_name' /* 英文名称 */)"></a-input>
                </a-form-item>
                <a-form-item :label="$t('web.sort' /* 排序 */)">
                    <a-input-number
                        v-decorator="['orderbyid', { initialValue: 0, rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('web.sort' /* 排序 */) }] }]"
                        :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('web.sort' /* 排序 */)"
                    ></a-input-number>
                </a-form-item>
                <a-form-item :label="$t('program.forum_info' /* 分论坛信息 */)">
                    <tinymce-editor v-decorator="['class_info']"></tinymce-editor>
                </a-form-item>
                <a-form-item :label="$t('formConfig.remark' /* 备注 */)">
                    <a-textarea v-decorator="['remarks']" :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('formConfig.remark' /* 备注 */)" :rows="4"></a-textarea>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';
import tinymceEditor from '@/components/Tinymce/index.vue';

const fileds = ['class_cnname', 'class_enname', 'orderbyid', 'remarks', 'id', 'class_info'];

export default {
    name: 'ClassUpdateModal',
    components: { tinymceEditor },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        show(data) {
            this.visible = true;
            if (data && data.id) {
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(data, fileds));
                });
            }
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    values.xuezu_id = values.id;
                    delete values.id;
                    this.$request
                        .post({ url: 'addEditXueZu', data: values })
                        .then(res => {
                            this.$message.success(this.form.getFieldValue('id') ? this.$t('web.modify_success' /* 修改成功 */) : this.$t('web.add_success' /* 添加成功 */));
                            this.confirmLoading = false;
                            this.handleCancel();
                            this.$emit('closeClassUpdate');
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-input-number {
    width: 100%;
}
</style>
